import React from 'react'
import './style.css'
import PropTypes from 'prop-types'


const ContentContainer = ({
                              padding = false,
                              center = true
                              , ...props
                          }) => {


    const style = {
        margin: !!center ? '0 auto' : '',
        padding: padding ? '0 1rem' : '',
        ...props.style
    }

    return (
        <div   {...props}
               style={style}

               className={'nrt-content-container ' + props.className}>
            {props.children}
        </div>
    )


}

ContentContainer.propTypes = {
    center: PropTypes.bool,
    padding: PropTypes.bool,
    className: PropTypes.string,
}


export default ContentContainer


// WEBPACK FOOTER //
// ./src/components/_common/_containers/ContentContainer/index.js